import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import SectionsRow from './SectionsRow.jsx';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Sections = () => {
  const [sections, setSections] = useState([]);
  const { SetNotification } = useStateContext();
  const [lang, setLang] = useState('English');
  const [loading, setIsLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);

  const fetchData = async () => {
    try {
      const response = await AxiosClient.get('/sections');
      const _sections = response.data;
      setSections(_sections);
      setIsLoading(false);
    } catch (error) {
      SetNotification('Error fetching data', 'danger');
    }
  };

  useEffect(() => {
    if (conferenceId !== undefined) {
      fetchData();
    }
  }, [conferenceId]);

  const handleDeleteArt = async (id) => {
    try {
      await AxiosClient.delete(`/sections/${id}`);
      fetchData();
      SetNotification('An article has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the section', 'danger');
    }
  };

  // Filter sections by both conferenceId and lang
  const filteredSections = sections.filter((section) => {
    return (
      section.conference_id === conferenceId && section.language === lang
    );
  });

  return (
    <div className="p-4">
      <div className="d-flex">
        <label className="h6 mb-0 h6 m-3">
          Language
        </label>

        <button
          className={`btn btn-${lang === 'Arabic' ? 'info' : 'dark'} m-2`}
          onClick={() => setLang('Arabic')}
        >
          Arabic
        </button>
        <button
          className={`btn btn-${lang === 'English' ? 'info' : 'dark'} m-2`}
          onClick={() => setLang('English')}
        >
          English
        </button>
        {lang === 'Arabic' ? (
          <img src="https://flagsapi.com/IQ/shiny/64.png" alt="Arabic" />
        ) : (
          <img src="https://flagsapi.com/GB/shiny/64.png" alt="English" />
        )}
      </div>

      {conferenceId && (
        <div>
          <div className="m-3">
            <Link className="btn btn-dark m-2" to="./Add">
              <i className="material-icons">add_box</i> | Add a new Section
            </Link>
            <Link className="btn btn-warning m-2" to={`./sort/${conferenceId}/${lang}`}>
              <i className="material-icons">add_box</i> | Manage Sections Order
            </Link>
          </div>
<div className="card-body px-0 pb-2">
  <div className="p-0 text-center o-verflowauto">
    {loading ? (
      <Loader label="Loading sections..." />
    ) : (
      <table className="table align-items-center justify-content-center mb-0 w-full border border-gray-300 table-fixed">
        <thead>
          <tr>
            <th className="p-2 border-b w-1/5">Title</th>
            <th className="p-2 border-b w-3/5">Description</th>
            <th className="p-2 border-b w-1/5">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredSections.length > 0 ? (
            filteredSections.map((sectionItem) => (
              <SectionsRow
                key={sectionItem.id}
                title={sectionItem.title}
                description={sectionItem.description}
                id={sectionItem.id}
                onDelete={handleDeleteArt}
              />
            ))
          ) : (
            <tr>
              <td colSpan="3" className="p-4 text-gray-500">
                No sections available for this conference and language
              </td>
            </tr>
          )}
        </tbody>
      </table>
    )}
  </div>
</div>






        </div>
      )}
    </div>
  );
};

export default Sections;
